export const SET_PAGE_NAME = "SET_PAGE_NAME";
export const SET_PAGE_TITLE_DESCRIPTION = "SET_PAGE_TITLE_DESCRIPTION";
export const SET_CAN_ACCESS_VIEW = "SET_CAN_ACCESS_VIEW";
